import { applicationFeesApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_CIC_FEE_REASONS_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/cicFeeReasons`,
  {
    GET_LOAN_CIC_FEE_REASONS: 'GET_LOAN_CIC_FEE_REASONS',
    EDIT_LOAN_CIC_FEE_REASONS: 'EDIT_LOAN_CIC_FEE_REASONS',
  },
);

export const getLoanCicFeeReasonsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationFeesApi.getLoanFeesReasons(params);

  return dispatch({
    type: LOAN_CIC_FEE_REASONS_ACTION_TYPE.GET_LOAN_CIC_FEE_REASONS,
    payload: data.cicFeeReasons,
  });
});

export const editLoanCicFeeReasonsAction = params => async dispatch => {
  const { data } = await applicationFeesApi.editLoanFeesReasons(params);

  return dispatch({
    type: LOAN_CIC_FEE_REASONS_ACTION_TYPE.EDIT_LOAN_CIC_FEE_REASONS,
    payload: data,
  });
};
